module.exports = __webpack_public_path__ + "media/src/images/icons/eye-open-4e5e78900e5cf69217f6fcd6508f0b05.svg";